import {useMemo} from 'react';

import {Theme} from 'utilities/color';
import {useI18n} from 'utilities/i18n';
import {DeliveryAddress, useLocation} from 'utilities/location';
import {Line, ShopPromiseLayout, Slot, UiLineType} from 'layouts';
import {useDeliveryEstimate} from 'utilities/delivery-promise';
import {trackError} from 'utilities/tracking';

import {FormattedAddress, ShopPromiseExpansionBlock} from './components';

export function ErrorMessage({
  fontOverride = false,
  isLoading = false,
  theme = Theme.Light,
  errorCode = undefined,
}: {
  fontOverride?: boolean;
  isLoading?: boolean;
  theme?: Theme;
  errorCode?: string;
}) {
  const {translate} = useI18n();
  const errorText = translate('error.generic');
  const {defaultAddress, postalCode} = useLocation();
  const {deliveryEstimate} = useDeliveryEstimate();

  const address = useMemo(() => {
    if (deliveryEstimate?.deliveryAddress) {
      return deliveryEstimate.deliveryAddress;
    } else if (postalCode) {
      return {
        zip: postalCode,
      } as DeliveryAddress;
    }
    return defaultAddress;
  }, [deliveryEstimate, defaultAddress, postalCode]);

  trackError({deliveryEstimate, postalCodeOverride: postalCode, errorCode});

  return (
    <ShopPromiseLayout
      fontOverride={fontOverride}
      hasBrand={false}
      isHidden={false}
      isLoading={isLoading}
      theme={theme}
    >
      <Slot name="Content">
        <Line type={UiLineType.ErrorLine}>{errorText}</Line>
        <Line type={UiLineType.DestinationFullWidth}>
          <FormattedAddress address={address} truncate={Boolean(postalCode)} />
        </Line>
      </Slot>
      <ShopPromiseExpansionBlock isLoading={isLoading} showLogo={false} />
    </ShopPromiseLayout>
  );
}
